
/* injects from baggage-loader */

import React, { Component } from "react";
import { connect } from "react-redux";
import { createSelector } from "reselect";
import { Link } from "react-router";
import PropTypes from "prop-types";
import { sportGamesCount, toggleGameEventsInList } from "../../../actions/ui";
import Config from "../../../config/main";

class Sport extends Component {
    componentDidMount () {
        if (this.props.data.alias === this.props.sportAlias) {
            return this.props.dispatch(sportGamesCount(this.props.data.game));
        }
    }
    componentDidUpdate () {
        if (this.props.data && this.props.sportAlias) {
            if (this.props.data.alias === this.props.sportAlias) {
                return this.props.dispatch(sportGamesCount(this.props.data.game));
            }
        }
        return;
    }

    closeOpenedGame () {
        this.props.isGameOpened && this.props.dispatch(toggleGameEventsInList(false, 0));
    }

    render () {
        let {data, sportAlias} = this.props;
        return (<Link onClick={() => this.closeOpenedGame()} className={data.alias === sportAlias ? "active " + data.alias : ""} key={data.id} ref={(input) => {
            this[data.alias] = input;}} to={`/${this.props.gameType}/${data.alias}${this.props.gameType === "topGames" || this.props.gameType === "esports" ? "/all" : ''}`}>
                <span className={"sport-icon-m " + (data.alias === "3x3Basketball" ? "Basketball3x3" : data.alias)}>
                    <i className="games-count-view-m">{data.game}</i>
                </span>
            <p>{data.name}</p>
        </Link>);
    }
}

Sport.propTypes = {
    gameType: PropTypes.string,
    data: PropTypes.object,
    sportAlias: PropTypes.string
};

const mapStateToProps = (state, ownParams) => {
    return createSelector(
        [
            state => JSON.stringify(state.swarmData.data[ownParams.selectorKey][ownParams.index]),
            state => state.uiState.sportGamesCount,
            state => state.uiState.multiComponent.bool
        ],
        (data, sportGamesCount, isGameOpened) => {
            return {
                data: data && JSON.parse(data),
                sportGamesCount,
                isGameOpened
            };
        }
    );
};

export default connect(mapStateToProps)(Sport);